var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPillarCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 44.5H30C40 44.5 44 40.5 44 30.5V18.5C44 8.5 40 4.5 30 4.5H18C8 4.5 4 8.5 4 18.5V30.5C4 40.5 8 44.5 18 44.5Z",
    stroke: "#5C6066",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20.5C20.2091 20.5 22 18.7091 22 16.5C22 14.2909 20.2091 12.5 18 12.5C15.7909 12.5 14 14.2909 14 16.5C14 18.7091 15.7909 20.5 18 20.5Z",
    stroke: "#5C6066",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33984 38.4001L15.1998 31.7801C16.7798 30.7201 19.0598 30.8401 20.4798 32.0601L21.1398 32.6401C22.6998 33.9801 25.2198 33.9801 26.7798 32.6401L35.0998 25.5001C36.6598 24.1601 39.1798 24.1601 40.7398 25.5001L43.9998 28.3001",
    stroke: "#5C6066",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillarCover);
export default __webpack_public_path__ + "static/media/pillar-cover.43051164358ae1d8e5d066fe207ce7dd.svg";
export { ForwardRef as ReactComponent };